const fieldIndices = {
  START_DATE_INDEX: 0,
  START_TIME_INDEX: 1,
  END_DATE_INDEX: 2,
  END_TIME_INDEX: 3,
  RECUR_TYPE_INDEX: 4,
  LOCATION_TYPE_INDEX: 5,
  LOCATION_VALUE_INDEX: 6,
  NOTIFY_BEFORE_INDEX: 7
};

export default fieldIndices;